export const convertUTCToLocal = (utcDateString) => {
  if (!utcDateString) return null;

  // Create Date object from UTC string
  const utcDate = new Date(utcDateString);

  // Extract UTC date components
  const year = utcDate.getUTCFullYear();
  const month = utcDate.getUTCMonth() + 1; // Months are zero-based
  const day = utcDate.getUTCDate();

  // Format as YYYY-MM-DD
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const convertISOToLocal = (isoDateString) => {
  if (!isoDateString) return null; // Handle null or invalid input
  const date = new Date(isoDateString);
  return date.toLocaleString();
};

export const formatDateToLocalYYYYMMDD = (dateString) => {
  if (!dateString) return '';

  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return '';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const formatDateToMMDDYYYY = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
};

export const parseYmdToUtcDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return null;

  const dateOnly = dateString.split('T')[0];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) return null;

  const [yStr, mStr, dStr] = dateOnly.split('-');
  const y = Number(yStr);
  const m = Number(mStr);
  const d = Number(dStr);
  if (!y || !m || !d) return null;

  const dt = new Date(Date.UTC(y, m - 1, d));
  return Number.isNaN(dt.getTime()) ? null : dt;
};
